type IdleRequest = ( cb: () => void, opts?: { timeout: number } ) => number;

const idle_request: IdleRequest | null =
  typeof window !== "undefined" && typeof ( window as { requestIdleCallback?: IdleRequest } ).requestIdleCallback === "function"
    ? ( window as unknown as { requestIdleCallback: IdleRequest } ).requestIdleCallback.bind( window )
    : null;

export function runWhenIdle( fn: () => void, timeout_ms: number ): void
{
  if ( idle_request )
    idle_request( fn, { timeout: timeout_ms } );
  else
    fn();
}
